import CachedResourceStore from '@/store/modules/CachedResourceStore'
import { BillOfLading } from '@/models/BillOfLading'

export default new CachedResourceStore<BillOfLading>(BillOfLading, {
	namespaced: true
})
